import { Event } from '@sentry/react/types';

export const isErrorFromChromeExtension = (event: Event): boolean =>
  event.exception?.values?.some((value) =>
    value.stacktrace?.frames?.some((frame) => frame.filename?.startsWith('chrome-extension://')),
  ) ?? false;
